import React, { useEffect, useState } from "react";
import { getWebsiteHealth } from "../services/AdminService";
import { Card, CardContent } from "../Ui/card";
import { Loader2 } from "lucide-react";
import { motion } from "framer-motion";

const WebsiteHealth = () => {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHealth = async () => {
      try {
        const data = await getWebsiteHealth();
        setHealth(data);
      } catch (err) {
        console.error("Error fetching health:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchHealth();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Loader2 className="animate-spin h-8 w-8 text-blue-500" />
      </div>
    );
  }

  if (!health) {
    return <p className="text-red-500 text-center">Failed to fetch health data</p>;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
    >
      <Card className="p-4 shadow-md">
        <CardContent>
          <h3 className="text-lg font-bold">Status</h3>
          <p className="text-green-600">{health.status}</p>
        </CardContent>
      </Card>

      <Card className="p-4 shadow-md">
        <CardContent>
          <h3 className="text-lg font-bold">Uptime</h3>
          <p>{Math.floor(health.uptime / 60)} mins</p>
        </CardContent>
      </Card>

      <Card className="p-4 shadow-md">
        <CardContent>
          <h3 className="text-lg font-bold">Node Version</h3>
          <p>{health.nodeVersion}</p>
        </CardContent>
      </Card>

      <Card className="p-4 shadow-md">
        <CardContent>
          <h3 className="text-lg font-bold">Memory</h3>
          <p>
            {(health.memoryUsage.heapUsed / 1024 / 1024).toFixed(2)} MB /{" "}
            {(health.totalMemory / 1024 / 1024).toFixed(2)} MB
          </p>
        </CardContent>
      </Card>

      <Card className="p-4 shadow-md">
        <CardContent>
          <h3 className="text-lg font-bold">Database</h3>
          <p className="text-green-600">{health.database}</p>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default WebsiteHealth;
